import "./list.scss"

import DatatableProduct from "../../../pages/products/ProductDataTable/DatatableProduct"

const List = () => {
  return (
    <div className="list">
      
      <div className="listContainer">
       
        <DatatableProduct />
      </div>
    </div>
  )
}

export default List